let flashHideTimeout = null;

function showFlashMessage(message, type = "notice", useTimeout=true) {
  const alertClass = type === "alert" ? "alert-danger" : "alert-success";

  clearTimeout(flashHideTimeout);
  $(".js-flash-message").remove();

  const $flash = $("<div></div>")
    .addClass("alert")
    .addClass(alertClass)
    .addClass("js-flash-message")
    .html(message);

  const $navbar = $("#content > nav.navbar");
  if ($navbar.length) {
    $navbar.after($flash);
  } else {
    $("#content").prepend($flash);
  }

  if (useTimeout) {
    flashHideTimeout = setTimeout(function () {
      $flash.fadeOut(300, function () {
        $(this).remove();
      });
    }, 5000);
  }
}

window.showFlashMessage = showFlashMessage;
